/**
 * Who may enter Platform Settings: SaleFish Admins — the SUPER_ADMIN role,
 * which the app labels "SaleFish Admin" — and nobody else (Andrew, 2026-09-28).
 *
 * Every door into the section asks THIS function: the route guard, the sidebar
 * and tab-bar entries, the layered modal, the breadcrumb, the health line. It
 * used to be `SUPER_ADMIN || ADMIN`, repeated in nine files. The reserved
 * ADMIN role holds no users today, but a second role quietly admitted in nine
 * places is exactly how a rule drifts; changing who is let in is now a one-line
 * diff here, mirrored by requireSuperAdmin on the server.
 */
export function canAccessPlatformSettings(user: { role?: string | null } | null | undefined): boolean {
  return user?.role === "SUPER_ADMIN";
}

/**
 * Who may enter Company Settings: the company's own admins (`isCompanyAdmin`)
 * and SaleFish Admins (Andrew, 2026-09-28). The server has always refused
 * anyone else (`companyAdminMiddleware`); the route itself did not, so a plain
 * member reaching `/company-admin` got a screen of load errors instead of a
 * refusal. Every door — the route guard, the sidebar and tab-bar entries, the
 * layered modal and the breadcrumb — asks this.
 */
export function canAccessCompanySettings(
  user: { role?: string | null; isCompanyAdmin?: boolean | null } | null | undefined,
): boolean {
  return user?.role === "SUPER_ADMIN" || user?.isCompanyAdmin === true;
}
